import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  question: 'WHAT ARE YOUR HOURS OF OPERATION?',
  answer: 'MK Lounge is open 7 days a week. Monday – Thursday: 4:00 PM – 2:00 AM, Friday: 4:00 PM – 3:00 AM, Saturday & Sunday: 2:00 PM – 3:00 AM. Happy Hour specials are available Monday – Friday from 4:00 PM – 6:00 PM.'
}, {
  question: 'IS THERE A DRESS CODE?',
  answer: 'Yes, we enforce a strict dress code to maintain the upscale atmosphere of MK Lounge. No athletic wear, sweatpants, overly baggy clothing, or work boots. Fashionable sneakers are permitted. Entry is always at the discretion of the door staff.'
}, {
  question: 'HOW DO I BOOK BOTTLE SERVICE?',
  answer: 'Bottle service can be booked directly through our Reservations page. We recommend booking at least 48 hours in advance, especially for weekends and special events. A deposit is required to secure your table.'
}, {
  question: 'DO YOU SERVE FOOD?',
  answer: 'Yes! We offer a curated menu of premium lounge bites, including our famous wings, sliders, and shareable platters. The kitchen is open until 1 hour before closing.'
}, {
  question: 'IS THERE A COVER CHARGE?',
  answer: 'Cover charges vary depending on the night, the time of arrival, and special events or guest DJs. We recommend arriving early or booking a VIP table to guarantee entry.'
}, {
  question: 'DO YOU HOST PRIVATE EVENTS?',
  answer: 'Absolutely. MK Lounge is available for private events, corporate gatherings, and birthday celebrations. Please visit our Contact page to submit an inquiry, and our events team will get back to you.'
}, {
  question: 'WHAT IS THE AGE REQUIREMENT?',
  answer: 'MK Lounge is strictly 21 and over. A valid, physical, government-issued ID or passport is required for entry. No exceptions.'
}];
export function FAQPage({
  onBack
}: {
  onBack: () => void;
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="min-h-screen w-full bg-[#050505] pt-24 pb-20 px-4 sm:px-6" data-id="element-1012">
      <div className="max-w-4xl mx-auto" data-id="element-1013">
        {/* Back */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} onClick={onBack} className="flex items-center gap-2 font-montserrat text-[12px] tracking-widest text-white/40 hover:text-[#C9A84C] transition-colors duration-300 mb-10" data-id="element-1014">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" data-id="element-1015">
            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1016" />
          </svg>
          BACK TO HOME
        </motion.button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-1017">
          <span className="font-inter text-[13px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-1018">
            Information
          </span>
          <h1 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-1019">
            FAQ
          </h1>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4 mb-4" data-id="element-1020" />
          <p className="font-inter text-[15px] text-white/50 max-w-xl mx-auto" data-id="element-1021">
            Everything you need to know before your visit to MK Lounge.
          </p>
        </motion.div>

        {/* FAQ List */}
        <div className="space-y-4" data-id="element-1022">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-[#C9A84C]/30 bg-[#C9A84C]/5' : 'border-white/10 bg-white/5 hover:border-white/20 hover:bg-white/10'}`} data-id="element-1023">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-1024">
                  <span className={`font-montserrat font-700 text-[14px] sm:text-[15px] tracking-widest transition-colors duration-300 ${isOpen ? 'text-[#C9A84C]' : 'text-white'}`} data-id="element-1025">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 ml-4 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-[#C9A84C] text-[#050505]' : 'bg-white/10 text-white/50'}`} data-id="element-1026">
                    {isOpen ? <MinusIcon size={16} data-id="element-1027" /> : <PlusIcon size={16} data-id="element-1028" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-1029">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-1030">
                      <div className="px-6 pb-6 pt-2" data-id="element-1031">
                        <div className="w-8 h-px bg-[#C9A84C]/30 mb-4" data-id="element-1032" />
                        <p className="font-inter text-[15px] leading-relaxed text-white/60" data-id="element-1033">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Contact CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-16 text-center" data-id="element-1034">
          <p className="font-inter text-[14px] text-white/50 mb-4" data-id="element-1035">
            Still have questions?
          </p>
          <button onClick={() => {
          // Assuming goPage('contact') is passed down or handled via context in a real app
          // For now, we'll just scroll to top as a placeholder if we can't navigate directly
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="font-montserrat font-700 text-[13px] tracking-widest border border-[#C9A84C]/40 text-[#C9A84C] px-8 py-3 rounded hover:bg-[#C9A84C]/10 hover:border-[#C9A84C] transition-all duration-300" data-id="element-1036">
            CONTACT US
          </button>
        </motion.div>
      </div>
    </div>;
}